import React from 'react';

export default ({children}) => <h1 className='pageTitle'>{children}</h1>;
